import { render, staticRenderFns } from "./SelectTemplateModal.vue?vue&type=template&id=04e53cbe&scoped=true"
import script from "./SelectTemplateModal.vue?vue&type=script&lang=js"
export * from "./SelectTemplateModal.vue?vue&type=script&lang=js"
import style0 from "./SelectTemplateModal.vue?vue&type=style&index=0&id=04e53cbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e53cbe",
  null
  
)

export default component.exports